import Block from '../block'

export default class AccountNav extends Block {
	static title = 'account-nav'

	init() {
		if (!this.hasModifier('mobile')) {
			return
		}

		this.getElement('toggle').addEventListener('click', () => this.toggle())
	}

	toggle() {
		this.toggleModifier('mobile-active')
	}
}
